import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectAllOnClickDirective } from './select-all-on-click.directive';

@NgModule({
  declarations: [
    SelectAllOnClickDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SelectAllOnClickDirective
  ]
})
export class DirectivesModule { }